import Button from "../UI/Button";
import {
  dialogNotify,
  displayNotImplemented,
} from "../../services/Notifications/NotificationServices";
import Select from "../UI/Select";
import ProfileEditModal from "../../../pages/Cabinet/components/ProfileEditModal/ProfileEditModal";
import { useEffect, useState } from "react";
import usePlayerAvatar from "../../../pages/Cabinet/hooks/usePlayerAvatar";
import {
  getLogin,
  initiateLogout,
  redirectToLogin,
  redirectToRegistration,
} from "../../../pages/Login/services/authService";
import { Link } from "react-router";
import Image from "../other/Image/Image";
import { title } from "process";
import UserNotificationModal from "../../../pages/Cabinet/components/modal/UserNotificationModal";
import NavBarMenu from "./NavBarMenu";
import { isDebugMode } from "../../utils/isDebugMode";

function isLogged() {
  return getLogin() != null;
}

function exit() {
  initiateLogout();
}

function Navbar() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 612);
  const [isOpenMenu, setIsOpenMenu] = useState(false);

  const debugMode = isDebugMode();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 612);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isOpenMenu) {
      document.body.classList.add("blackout");
    } else {
      document.body.classList.remove("blackout");
    }

    return () => document.body.classList.remove("blackout");
  }, [isOpenMenu]);

  const handleOverlayClick = () => {
    setIsOpenMenu(false);
  };

  const buttons = (
    <>
      <Button onClick={redirectToLogin} className="navbar_loginButton">
        Войти
      </Button>
      <Button
        onClick={redirectToRegistration}
        className="navbar_registrationButton"
      >
        Регистрация
      </Button>
    </>
  );

  const login = getLogin();

  const { data } = usePlayerAvatar(login || "");

  const avatar = data?.avatar_link;

  const bucketUrl =
    window.location.hostname == "cybershtab.ru"
      ? "https://media.cybershtab.ru/cybershtab-front"
      : "http://10.244.0.191:8333/cybershtab-local-bucket";

  const userInfo = (
    <>
      <div className="navbar_userInfo">
        <Link to={`/Cabinet/${login}`}>
          <Image
            className="navbarAvatar"
            resolution="avatar"
            src={
              avatar ? avatar : "../EmptyProfileSection/ava_empty162x162.png"
            }
            alt=""
          />
        </Link>
        <span className="navbar_userLogin" title={login ?? undefined}>
          {login}
        </span>
      </div>
    </>
  );

  const content = !isLogged() ? buttons : userInfo;

  const profileOption = (
    <a className="select_option" href={`/Cabinet/${login}`}>
      Профиль
    </a>
  );
  const editProfileOption = (
    <Link className="select_option" to={`/Cabinet/${login}?profileEdit=true`}>
      Редактировать профиль
    </Link>
  );
  const myPurchases = (
    <Link className="select_option" to={`/my-purchases`}>
      Мои подписки
    </Link>
  )
  const exitOption = (
    <div
      className="select_option"
      onClick={() =>
        dialogNotify({
          title: "Выход",
          status: "info",
          description: "Вы уверены, что хотите выйти?",
          acceptHandler: exit,
          acceptText: "Выйти",
          rejectText: "Отмена",
        })
      }
    >
      Выйти
    </div>
  );

  const my_teams = (
    <Link className="select_option" to={`/teams?my=true`}>
      Мои команды
    </Link>
  );

  const my_hosts = (
    <Link className="select_option" to={`/organizers?my=true`}>
      Мои орггруппы
    </Link>
  );

  const my_armories = (
    <Link className="select_option" to={`/Cabinet/${login}?armories=true`}>
      Мои привода
    </Link>
  );

  const my_notifications = (
    <Link to={`/Cabinet/${login}?notifications=true`}>
      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_9801_12881)">
          <path d="M8.25 3.66602C8.25 2.93667 7.96027 2.2372 7.44454 1.72147C6.92882 1.20575 6.22935 0.916016 5.5 0.916016C4.77065 0.916016 4.07118 1.20575 3.55546 1.72147C3.03973 2.2372 2.75 2.93667 2.75 3.66602C2.75 6.87435 1.375 7.79102 1.375 7.79102H9.625C9.625 7.79102 8.25 6.87435 8.25 3.66602Z" stroke="#F7F8F8" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M6.29286 9.625C6.21228 9.76391 6.09663 9.87922 5.95747 9.95937C5.81831 10.0395 5.66054 10.0817 5.49995 10.0817C5.33936 10.0817 5.18158 10.0395 5.04243 9.95937C4.90327 9.87922 4.78761 9.76391 4.70703 9.625" stroke="#F7F8F8" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
          <clipPath id="clip0_9801_12881">
            <rect width="11" height="11" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Link>
  )

  //корзина покупок
  // const cart = (
  //   <Link to='/checkout'>
  //     <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="11" viewBox="0 0 11 11" width="11">
  //       <g clip-path="url(#a)">
  //         <path d="M1.375 1.375h.917l1.183 5.917a.9.9 0 0 0 .896.725h3.796a.9.9 0 0 0 .896-.725l.562-3.167H2.75" stroke="#f7f8f8" stroke-linecap="round" stroke-linejoin="round" />
  //         <path d="M4.583 9.938a.584.584 0 0 0 0-1.167.584.584 0 0 0 0 1.166M8.167 9.938a.584.584 0 0 0 0-1.167.584.584 0 0 0 0 1.166" fill="#f7f8f8" />
  //       </g>
  //       <defs>
  //         <clipPath id="a">
  //           <path d="M0 0h11v11H0z" fill="#fff" />
  //         </clipPath>
  //       </defs>
  //     </svg>
  //   </Link>
  // )

  return (
    <>
      {isOpen && (
        <ProfileEditModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        ></ProfileEditModal>
      )}
      {isMobile && isOpenMenu && (
        <div className="navbarMenu_overlay" onClick={handleOverlayClick}></div>
      )}
      <nav className="bordered navbar">
        <Link className="navbarSkull" to="/promo">
          <img src="/skull.svg" alt="" />
        </Link>
        <Link className="navbar-ref" to="/promo">
          Главная
        </Link>
        <Link className="navbar-ref" to="/devicesoverview">
          Продукты
        </Link>
        <Link className="navbar-ref" to="/calendar?state=announced&state=registration_opened&state=registration_closed&state=in_progress">
          Игры
        </Link>
        {!isMobile && (
          <>
            <Link className="navbar-ref" to="/teams">
              Команды
            </Link>
            <Link className="navbar-ref" to="/organizers">
              Организаторы
            </Link>
            {/* <a
              onClick={() => {
                displayNotImplemented();
              }}
              className="navbar-ref"
            >
              <img
                className="navbar-search-icon"
                src="/search.svg"
                alt="Поиск"
              />
            </a> */}

            {isLogged() && debugMode && my_notifications}
            {/* {isLogged() && debugMode && cart} корзина покупок, не удалять */}

            {isLogged() ? (
              <div className="navbar-select-wrapper">
                <Select
                  options={[
                    profileOption,
                    editProfileOption,
                    myPurchases,
                    my_teams,
                    my_hosts,
                    my_armories,
                    exitOption,
                  ]}
                  value={content}
                  isChangeable={false}
                  classes={{ select_arrow: "navbarSelectArrow" }}
                ></Select>
              </div>
            ) : (
              content
            )}
          </>
        )}
        {isMobile && (
          <button
            onClick={() => {
              if (isOpenMenu) setIsOpenMenu(false);
              else setIsOpenMenu(true);
            }}
          >
            <img src="/burger-menu.svg" />
          </button>
        )}
        {isMobile && isOpenMenu && (
          <NavBarMenu
            isLogged={isLogged()}
            login={login}
            avatar={avatar}
            exit={exit}
          />
        )}
      </nav>
    </>
  );
}

export default Navbar;
